import { Link } from 'react-router-dom';
import {
  AgeTypes,
  ByCodeTypes,
  InsuranceTypes,
  ReportInitialState,
  OutlookTypes
} from "./model/report";
import { DropdownItemProps, SemanticICONS } from 'semantic-ui-react';
import { StatusType } from './model/StatusType';
export const API_URL: string = process.env.NODE_ENV === "development"
  ? "http://localhost:5006"
  : "https://apireferout.cdp.dental";

  export interface SubMenux {
    pageId: number;
    name: string;
    icon: SemanticICONS;
    title: string;
    role: string[];
    hide?: boolean;
    customIcon?: string;
  }
export interface SubMenu {
  pageId: number;
  class: string;
  name: string;
  icon?: SemanticICONS;
  title: string;
  role: string[];
  hide?: boolean;
  customIcon?: string;
  subMenux?: SubMenux[];
}

export interface MainMenu {
  class: string;
  customIcon?: string;
  icon: SemanticICONS;
  name: string;
  pageId: number;
  partner: string;
  subMenus?: SubMenu[];
  title: string;
  role: [];
  hide?: boolean;
}

export const brands = [
  {text: 'SDD', value: 'SDD', key: 'SDD'},
  {text: '3CD', value: '3CD', key: '3CD'},
  {text: 'FSD', value: 'FSD', key: 'FSD'},
  {text: 'OTD', value: 'OTD', key: 'OTD'},
  {text: 'SMD', value: 'SMD', key: 'SMD'},
  {text: 'AMD', value: 'AMD', key: 'AMD'},
];

export const navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE',
}



export const aptStatus:StatusType[] = [
  {id: 0, referStatus: '', statusColor: ''},
  {id: 1, referStatus: 'Scheduled', statusColor: '#b46851'},
  {id: 2, referStatus: 'Complete', statusColor: '#278b23'},
  {id: 3, referStatus: '', statusColor: ''},
  {id: 4, referStatus: '', statusColor: ''},
  {id: 5, referStatus: 'Broken', statusColor: '#ff0000'}
] 

export const doctorPracticeTypes: { [key: string]: string } = {'1': '1 Dr', '2': '2 Dr', '3': 'Denovo'};
export const createDrListOptions = () => {
  let drListOptionsArray: any = [{key: '0', value: 0, text: 'Select DrType'}];
  if (Object.keys(doctorPracticeTypes).length) {
    Object.keys(doctorPracticeTypes).forEach((key: string) => {
      drListOptionsArray.push({text: doctorPracticeTypes[key], value: key, key: key})
    });
  }
  return drListOptionsArray;
};
createDrListOptions();

export enum myPartners {
  SCHEDULE = 'Schedule',
  SITES = 'Sites',
  DENTIST = 'Dentist',
  LEADS = 'Leads',
  PCR = 'PCR',
  ADMIN = 'Admin',
  OS_PCR = 'OS PCR',
  ORTHO_PCR = 'Ortho PCR',
  SPOT = 'SPOT',
  DCRM = 'DCRM',
  SPORE = 'SPORE',
  SCHEDULER='SCHEDULER',
  CLAIMS_TEAM='CLAIMS TEAM',
  CALL_CENTER='CALL CENTER',
  CSR = 'CSR',
  DIRECTORY_ORG_CHART='DIRECTORY_ORGCHART',
  ADJUSTMENT = 'Adjustment',
  FIVE9 ='Five9',
  MDM ='MDM',
  MDHM ='MDHM',
  PMD = 'PMD',
  RECRUIT = 'RECRUIT',
  XSD = 'XSD',
  PF = 'Patient Finance',
  CRED = 'Credentialing',
  MATRIX = 'User Matrix',
  REFERRALS='REFERRALS',
  MEMBERS='MEMBERS'
}





export const practiceType =[
  {key:'All', text:'All', value:'All'},
  {key:'Oral Surgery', text:'Oral Surgery', value:'oral'},
  {key:'Ortho', text:'Ortho', value:'ortho'}
];


export enum Months { }



export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);





export const leadStatus:DropdownItemProps[] =[
  {key:'Purge Won', text:'Purge Won', value:'Purge Won'},
  {key:'Purge Lost', text:'Purge Lost', value:'Purge Lost'}
];


export const allowDeleteUserId = [ 163, 1710, 791, 1189, 1180 ];





























export const providerList : any = {
  "DentaQuest" : "DENTA",
  "UHC Medicaid" : "UNITED HEALTH CARE"
};








export const acceptHelpFileTypes = ".mp4, .pdf";


export const HelpPages: any = {
  110: { name: "Referrals - All Referrals" },
  111: { name: "Referrals - Setup > Ortho > Procedure Codes" },
  112: { name: "Referrals - Setup > Ortho > Status Setup" },
  113: { name: "Referrals - Setup > Ortho > Notification" },
  114: { name: "Referrals - Setup > Oral Surgery > Procedure Codes" },
  115: { name: "Referrals - Setup > Oral Surgery > Status Setup" },
  116: { name: "Referrals - Setup > Oral Surgery > Notification" },
  117: { name: "Referrals - Reports" },
  118: { name: "Referrals - Usage" }
}

export enum HELP_PAGE{
  REFERRALS_ALL = 110,
  REFERRALS_SETUP_ORTHO_PROC_CODE,
  REFERRALS_SETUP_ORAL_PROC_CODE,
  REFERRALS_USAGE
}

export const LEAD_STATUS = ['New', 'In Progress', 'Won', 'Lost'];

export const CALL_RESULT = [
  "Left Message",
  "Left Voice Mail",
  "Made Contact",
  "No Answer",
  "No Message Left",
  "Not in Service",
  "Not Interested",
  "Wrong Number"
];


export const PREFERRED_TIMES = ['9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM',
    '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM'];

export const CALL_TYPE = ['Inbound', 'Outbound'];

export const LEAD_LOST_REASON = [
  "Attempts Completed",
  "Bad Reputation",
  "Duplicate",
  "Existing Patient",
  "Incorrect Contact Information",
  "Insurance",
  "Never Made Contact",
  "Not Interested",
  "Other",
  "Other Dentists",
  "Too Far"
];
